<template>
    <p>{{text}}</p>
</template>

<script>
    export default {
        name: "TitleRows",
        props: {
            text: {
                type: String,
                default: '基本信息'
            }
        }
    }
</script>

<style lang='less' scoped>
    p {
        font-weight: bold;
        line-height: 12vw;
        font-size: 4vw;
        color: #333333;
    }
</style>



// WEBPACK FOOTER //
// src/page/mine/setting/components/TitleRow.vue